// src/components/ui/Spinner.jsx
import React from "react";

export default function Spinner({ size = 5 }) {
  return (
    <div
      className={`animate-spin rounded-full h-${size} w-${size} border-2 border-primary-500 border-t-transparent`}
    />
  );
}
